import React from "react";
import TableWrapper from "../Table/tableWrapper";
import {useSelector} from "react-redux";
import {getUsageTable} from "../../Util/TableHelpers/usageTableHelper";
import { useFetchBillingDetailsQuery } from "../../Apis/billingApi";
import { useFetchCompanyInfosQuery } from "../../Apis/companyApi";
import { enterpriseDetailsSelector } from "../../Reducers/enterpriseDetailsReducer";
import { ownPermissionsSelector } from "../../Reducers/ownRoleReducer";
import styles from "./billingPageWrapper.module.css";

const UsageTableHeaders = ["Service Period", "Total Number of Accounts", "Total Number of Billed Accounts", "Gross Usage", "Discount", "Net Usage", "Details"]

const UsageSectionHeading = () => (
    <div className={styles.sectionHeader}>
        <span className="sub-title">Usage</span>
        <p className={styles.sectionSubheading}>
            Monthly totals aggregated from billing activity at each company in your network.
        </p>
    </div>
);

const UsageTableSection = () => {
    const tableOption = {
        firstChildHighlight: true
    }
    const partnerDetails = useSelector(enterpriseDetailsSelector);
    const ownPermissions = useSelector(ownPermissionsSelector);
    const { data: partnerAccountsObj } = useFetchCompanyInfosQuery();
    const { data: billingDataObj, isLoading, isError } = useFetchBillingDetailsQuery(undefined, {
        skip: !ownPermissions?.canReadBilling(),
    });

    const billingNotReady =
        partnerDetails == null
        || partnerAccountsObj == null
        || isLoading
        || billingDataObj == null;

    if (billingNotReady) {
        let errorText = "You do not have any usage";
        if (isLoading) errorText = "Loading usage...";
        if (isError) errorText = "Usage could not be loaded";

        return (
            <div className="row p-2 ps-0 min-width-md-parent">
                <UsageSectionHeading/>
                <TableWrapper tableHeaderArr={UsageTableHeaders} tableBodyArr={[]}
                              errorText={errorText}/>
            </div>
        );
    }

    const tableBodyArr = getUsageTable(billingDataObj.billingFormattedObj, partnerAccountsObj);

    return (
        <div className="row ps-0 min-width-md-parent">
            <UsageSectionHeading/>
            <TableWrapper tableHeaderArr={UsageTableHeaders} tableBodyArr={tableBodyArr} option={tableOption}/>
        </div>
    )
}

export default UsageTableSection;

